import { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
}

export const Card = ({ children, className = "" }: CardProps) => {
  return (
    <div className={`p-3 bg-white rounded-xl shadow hover:shadow-md transition-all ${className}`}>
      {children}
    </div>
  );
};
